<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.accmType" :label="labels.accmType" :error-messages="errors.collect('accmType')" data-vv-name="accmType" :data-vv-as="labels.accmType" v-validate="'max:2'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.blkDesc" :label="labels.blkDesc" :error-messages="errors.collect('blkDesc')" data-vv-name="blkDesc" :data-vv-as="labels.blkDesc" v-validate="'max:200'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.blkGrp" :label="labels.blkGrp" :error-messages="errors.collect('blkGrp')" data-vv-name="blkGrp" :data-vv-as="labels.blkGrp" v-validate="'max:10'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.blk" :label="labels.blk" :error-messages="errors.collect('blk')" data-vv-name="blk" :data-vv-as="labels.blk" v-validate="'max:15'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.blksGrp1" :label="labels.blksGrp1" :error-messages="errors.collect('blksGrp1')" data-vv-name="blksGrp1" :data-vv-as="labels.blksGrp1" v-validate="'max:10'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.blksGrp2" :label="labels.blksGrp2" :error-messages="errors.collect('blksGrp2')" data-vv-name="blksGrp2" :data-vv-as="labels.blksGrp2" v-validate="'max:8'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <cal-picker :label="labels.effDate" v-model="filters.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Block
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.accmType }}</td>
                <td class="text-xs-left">{{ row.item.blkGrp }}</td>
                <td class="text-xs-left">{{ row.item.blksGrp1 }}</td>
                <td class="text-xs-left">{{ row.item.blksGrp2 }}</td>
                <td class="text-xs-left">{{ row.item.blk }}</td>
                <td class="text-xs-left">{{ row.item.blkDesc }}</td>
                <td class="text-xs-left">{{ formatDate(row.item.effDate) }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doAction('edit', row.item)" query @query="doAction('query', row.item)" remove @remove="doPromptRemove"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Please confirm deletion of this records.
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Accumulation Type', align: 'left', value: 'accmType' },
        { text: 'Block Group', align: 'left', value: 'blkGrp' },
        { text: 'Block Sub Group 1', align: 'left', value: 'blksGrp1' },
        { text: 'Block Sub Group 2', align: 'left', value: 'blksGrp2' },
        { text: 'Block', align: 'left', value: 'blk' },
        { text: 'Description', align: 'left', value: 'blkDesc' },
        { text: 'Effective Date', align: 'left', value: 'effDate' },
        TableConst.tableActionHeader
      ],
      filters: {
        accmType: undefined,
        blkGrp: undefined,
        blksGrp1: undefined,
        blksGrp2: undefined,
        blk: undefined,
        blkDesc: undefined,
        effDate: undefined
      },
      labels: {
        accmType: 'Accumulation Type',
        blkGrp: 'Block Group',
        blksGrp1: 'Block Sub Group 1',
        blksGrp2: 'Block Sub Group 2',
        blk: 'Block',
        blkDesc: 'Block Description',
        effDate: 'Effective Date'
      },
      totalItems: 0,
      promptRemove: false,
      selectedBlk: {},
      loading: false,
      accmTypeList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInit(options) {
      const apiURI = this.menu.getBlkList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.effDate) {
            currFilters.effDate = formatDisplayDateTime2(removeTime(currFilters.effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((blk) => {
                const convertList = {
                  accmType: blk.accmType,
                  blkGrp: blk.blkGrp,
                  blksGrp1: blk.blksGrp1,
                  blksGrp2: blk.blksGrp2,
                  blk: blk.blk,
                  blkDesc: blk.blkDesc,
                  effDate: blk.effDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getAccmTypeList() {
      const apiURI = this.menu.getAccmTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.accmTypeList = []
        if (data) {
          data.map((accmType) => {
            const convertList = {
              label: accmType.accmType + ' - ' + accmType.accmTypeDesc,
              value: accmType.accmType
            }
            this.accmTypeList.push(convertList)
          })
        }
      }
    },
    doNew() {
      this.$router.push({
        name: 'blkReview',
        params: {
          mode: 'new',
          id: {}
        }
      })
    },
    doAction(mode, data) {
      this.$router.push({
        name: 'blkReview',
        params: {
          mode: mode,
          id: data
          // accmType: data.accmType,
          // blkGrp: data.blkGrp,
          // blksGrp1: data.blkGrp1,
          // blksGrp2: data.blkGrp2,
          // blk: data.blk,
          // effDate: data.effDate
        }
      })
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedBlk = data.item
      this.promptRemove = true
    },
    async doRemove(data) {
      const apiURI = this.menu.deleteBlk
      if (apiURI) {
        const expand = this.selectedBlk
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            this.message(data)
          })
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.accmType = undefined
      this.filters.blkGrp = undefined
      this.filters.blksGrp1 = undefined
      this.filters.blksGrp2 = undefined
      this.filters.blk = undefined
      this.filters.blkDesc = undefined
      this.filters.effDate = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    }
  },
  mounted() {
    this.doInit(true)
    this.getAccmTypeList()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
